import * as S from './styled';
import { T } from 'react-translator-component';
import { message, PageHeader, Result, Skeleton } from 'antd';
import CompanyForm from '../../organisms/CompanyForm/CompanyForm';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { getCompanyDetail, updateCompany } from '../../../hooks/company';

const CompanyEditPage = () => {
  const { id }: any = useParams();

  const [companyDetail, setCompanyDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const location: any = useLocation();

  const getCompanyDetailData = useCallback(async () => {
    try {
      setLoading(true);
      const responseDetail = await getCompanyDetail(id);
      setCompanyDetail(responseDetail);
    } catch (error) {
      setCompanyDetail({ error: true });
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getCompanyDetailData();
  }, [getCompanyDetailData]);

  const handleNavigateBack = () => {
    if (location.state?.isFrom === 'create') {
      history.replace('/vehicle/create', {
        plate: location.state.plate,
        isVehicle: true,
      });
    } else {
      history.replace(`/vehicle/${location.state.id}/edit`, {
        plate: location.state.plate,
        isVehicle: true,
      });
    }
  };

  const handleEditCompany = async (values: any) => {
    try {
      const response = await updateCompany(id, {
        name: values.name,
        nit: values.nit,
        sap_code: values.sapCode,
      });

      if (response && response.type === 'success') {
        message.success(T('Empresa atualizada com sucesso!'));

        handleNavigateBack();
      }
    } catch {
      message.error(T('Failed to update the company!'));
    }
  };

  if (loading || companyDetail === null) {
    return (
      <S.Wrapper>
        <Skeleton
          active
          paragraph={{ rows: 10, width: '100%' }}
          title={false}
        />
      </S.Wrapper>
    );
  }

  if (companyDetail?.error) {
    return (
      <S.Wrapper>
        <S.Blank>
          <Result
            status='warning'
            title={T('Failed to load the company!')}
            extra={[
              <S.Button type='primary' key='home'>
                <Link to='/'>{T('Go back')}</Link>
              </S.Button>,
              <S.Button key='reload' onClick={getCompanyDetailData}>
                {T('Try again')}
              </S.Button>,
            ]}
          />
        </S.Blank>
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <PageHeader
        onBack={() => handleNavigateBack()}
        title={T('Edit Company')}
      />

      <S.Blank>
        <CompanyForm
          initialValues={{
            name: companyDetail.name || '',
            nit: companyDetail.nit || '',
            sapCode: companyDetail.sapCode || '',
          }}
          loading={loading}
          isEdit={true}
          onSubmit={handleEditCompany}
        />
      </S.Blank>
    </S.Wrapper>
  );
};

export default CompanyEditPage;
